module.exports = __webpack_public_path__ + "img/PP_Sword_0222.5dc669a5.png";